import { Box, Typography, Divider } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import EMPChip from "../EMPChip/EMPChip";
import SharedToolTip from "../../sharedToolTip/SharedToolTip";

const EMPObjectCard = ({ data = {}, hasBackground, twoByTwo }) => {
  const spanValue = twoByTwo
    ? { xs: "span 6" }
    : { xs: "span 6", sm: "span 3", md: "span 2" };
  const dataKeys = Object.keys(data);
  const columnValue = dataKeys.length > 3 ? 12 : 6;

  return (
    <Box sx={{ height: "100%" }}>
      <Box
        sx={{
          border: hasBackground ? "none" : "1px solid #B2B2B2",
          borderRadius: 2,
          background: hasBackground
            ? "linear-gradient(135deg, #F5F6F7 0%, #FFFFFF 100%)"
            : "transparent",
          height: "inherit",
          padding: hasBackground ? "8px 56px" : 0,
        }}
        display="grid"
        gridTemplateColumns={`repeat(${columnValue}, 1fr)`}
        columnGap={4}
        rowGap={0}
        data-testid="object-card-grid-container"
      >
        {dataKeys.map((item, index) => {
          const isFirstItem = index === 0 || index === 6;
          const objectCardItem = data[item];

          let cardPadding = "16px";

          if (
            isFirstItem ||
            (twoByTwo && index % 2 === 0) ||
            (twoByTwo && index % 2 !== 0)
          ) {
            cardPadding = "16px 0px 16px 16px";
          } else if (!twoByTwo && !isFirstItem) {
            cardPadding = {
              xs: "16px",
              sm: "16px",
              md: "16px 16px 16px 0px",
            };
          }

          return (
            <React.Fragment key={objectCardItem.heading}>
              <Box
                data-testid="object-card-wrapper"
                gridColumn={spanValue}
                sx={{
                  padding: cardPadding,
                }}
              >
                <Typography variant="caption">
                  {objectCardItem.heading}{" "}
                  {objectCardItem.hasTooltip && (
                    <SharedToolTip body={objectCardItem.toolTipMessage} />
                  )}
                </Typography>

                {objectCardItem.highlight ? (
                  <Box>
                    <EMPChip
                      label={objectCardItem.content}
                      labelColor={objectCardItem.color}
                    />
                  </Box>
                ) : (
                  <Typography variant={hasBackground ? "body1" : "body2"}>
                    {objectCardItem.content}
                  </Typography>
                )}
              </Box>

              {twoByTwo
                ? (index + 1) % 2 === 0 &&
                  index + 1 < dataKeys.length && (
                    <Divider
                      sx={{ gridColumn: `span ${columnValue}`, my: 0 }}
                    />
                  )
                : (index + 1) % 6 === 0 &&
                  index + 1 < dataKeys.length && (
                    <Divider
                      sx={{ gridColumn: `span ${columnValue}`, my: 0 }}
                    />
                  )}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};

EMPObjectCard.propTypes = {
  data: PropTypes.objectOf(
    PropTypes.shape({
      heading: PropTypes.node,
      content: PropTypes.node,
      highlight: PropTypes.bool,
      color: PropTypes.oneOf([
        "default",
        "primary",
        "secondary",
        "error",
        "info",
        "success",
        "warning",
      ]),
      hasTooltip: PropTypes.bool,
      toolTipMessage: PropTypes.node,
    })
  ),
  hasBackground: PropTypes.bool,
  twoByTwo: PropTypes.bool,
};

export default EMPObjectCard;
